<template>
  <div class="content-body tenant-settings">
    <div class="">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="queryHandle()" size="small">
        <el-form-item label="子公司" prop="subcompanyIdList">
          <el-select v-model="dataForm.subcompanyIdList"
                     @change="getSupCompanyList"
                     placeholder="请选择子公司"
                     filterable
                     clearable
                     multiple
                     collapse-tags
                     popper-class="fixed-dropdown"
                     class="input-width">
            <el-option
                v-for="item in supCompanyList"
                :key="item.key"
                :label="item.label"
                :value="item.key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="A S N 编码:">
          <el-input size="small" v-model="dataForm.asncode" placeholder="ASN编码" clearable
                    @blur="queryHandle"></el-input>
        </el-form-item>
        <el-form-item label="物料号:">
          <el-input size="small" v-model="dataForm.partCode" placeholder="物料号" clearable
                    @blur="queryHandle"></el-input>
        </el-form-item>
        <el-form-item label="ASN状态:">
          <!-- <el-input size="small" v-model="dataForm.asnStatus" placeholder="ASN状态" clearable @blur="getDataList"></el-input> -->
          <el-select size="small" v-model="dataForm.asnStatus" placeholder="请选择ASN状态" clearable
                     @change="queryHandle">
            <el-option v-for="item in ASN_STATUS" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="采购组:">
          <el-select size="small" v-model="dataForm.ekgrp" placeholder="请选择采购组" filterable clearable
                     @change="queryHandle">
            <el-option v-for="item in GOURP_LIST" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="供货日期:">
          <el-date-picker size="small" v-model="dataForm.deliveryDateStart" style="width:140px"
                          value-format="yyyy-MM-dd" type="date" clearable placeholder="起始日期"></el-date-picker>
          <span style="margin:0 5px">~</span>
          <el-date-picker size="small" v-model="dataForm.deliveryDateEnd" style="width:140px"
                          value-format="yyyy-MM-dd" type="date" clearable placeholder="截止日期"></el-date-picker>
        </el-form-item>
        <el-form-item class="fr">
          <el-button size="small" @click="queryHandle()" icon="el-icon-search">
            查询
          </el-button>
          <el-button size="small" plain v-if="isAuth('sourcing:delivery:newbutton')" type="primary"
                     @click="exportASNData()">
            导出交货单信息
          </el-button>
          <el-button size="small" plain v-if="isAuth('sourcing:delivery:newbutton')" type="primary"
                     @click="importTemplate()">
            导入交货单信息
          </el-button>
          <el-button size="small" plain v-if="isAuth('sourcing:delivery:newbutton')" type="primary"
                     @click="addOrUpdateHandle()" icon="el-icon-plus">
            新建ASN
          </el-button>
        </el-form-item>
        <div>
          <el-form-item label="内向交货单:">
            <el-input size="small" v-model="dataForm.innerCode" placeholder="内向交货单" clearable
                      @blur="queryHandle"></el-input>
          </el-form-item>
          <el-form-item label="订单号:">
            <el-input size="small" v-model="dataForm.orderCode" placeholder="订单号" clearable
                      @blur="queryHandle"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div v-loading="dataListLoading">
        <el-table :data="dataList" row-key="id" size="mini" border style="width: 100%;" :default-expand-all="false"
                  :header-cell-style="{background:'#f5f5f5'}" :height="tableHeight">
          <el-table-column type="index" width="50" label="序号">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
            </template>
          </el-table-column>
          <el-table-column prop="bukrs" header-align="center" align="left" label="公司代码" width="150">
          </el-table-column>
          <el-table-column prop="asnStatus" header-align="center" align="center" label="ASN状态" width="100">
            <template slot-scope="scope">
                        <span :class="getStatusClass(scope.row.asnStatus)">
                            {{ asnStatusFormat(scope.row.asnStatus) }}
                        </span>
            </template>
          </el-table-column>
          <el-table-column prop="syncStatus" header-align="center" align="center" label="同步状态" width="100">
            <template slot-scope="scope">
                        <span :class="getStatusClass(scope.row.syncStatus)">
                            {{ syncStatusFormat(scope.row.syncStatus) }}
                        </span>
            </template>
          </el-table-column>
          <el-table-column prop="asncode" header-align="center" align="left" label="ASN编码" width="150">
          </el-table-column>
          <el-table-column prop="deliveryDate" header-align="center" align="center" label="供货日期"
                           :formatter="dateFormat" width="150">
          </el-table-column>
          <el-table-column prop="innerCode" header-align="center" align="left" label="内向交货单">
          </el-table-column>
          <el-table-column prop="groupCode" header-align="center" width="60" align="center" label="采购组">
          </el-table-column>
          <el-table-column prop="groupName" header-align="center" width="100" align="center" label="采购组描述">
          </el-table-column>
          <el-table-column prop="remark" header-align="center" align="left" label="备注">
          </el-table-column>
          <el-table-column prop="rejectReason" header-align="center" align="left" label="驳回原因">
          </el-table-column>
          <el-table-column prop="syncMessage" header-align="center" align="left" label="同步失败原因">
          </el-table-column>
          <el-table-column v-if="isAuth('sourcing:delivery:newbutton')" header-align="center" align="left" width="240"
                           label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="viewHandle(scope.row)" icon="el-icon-view">
                查看
              </el-button>
              <el-button
                  :disabled="scope.row.asnStatus !== '0' && scope.row.asnStatus !== '3'"
                  type="text" size="small" @click="addOrUpdateHandle(scope.row)" icon="el-icon-edit">
                修改
              </el-button>
              <el-button
                  :disabled="(scope.row.asnStatus === '1' || scope.row.asnStatus == '4')
                  || scope.row.asnStatus == '5'
                  || scope.row.syncStatus == '2'
                  || (scope.row.asnStatus == '2' && scope.row.syncStatus == '2')
                  || (scope.row.asnStatus == '2' && scope.row.syncStatus == '3')
                  || scope.row.autoGenerate === true"
                  type="text" size="small" @click="deleteHandle(scope.row.id)" icon="el-icon-delete"
                  class="text-danger">
                删除
              </el-button>
              <el-button :disabled="!isPrintButtonEnabled(scope.row)"
                         type="text"
                         size="small"
                         @click="exportData(scope.row)" icon="el-icon-edit">
                打印
              </el-button>
              <el-button :disabled="!((scope.row.asnStatus == '2'
                        || scope.row.asnStatus == '5'
                        ||scope.row.asnStatus == '6'
                        ||scope.row.asnStatus == '7'
                        ||scope.row.asnStatus == '8'
                        ||scope.row.asnStatus == '9') && scope.row.syncStatus == '2'&& scope.row.printFlag==1)"
                         type="text" size="small" @click="exportBoxLabelData(scope.row)" icon="el-icon-edit">
                打印箱标签
              </el-button>
              <el-button :disabled="!(scope.row.asnStatus === '7')" type="text" size="small"
                         @click="openDelivery(scope.row)" icon="el-icon-edit">
                发运
              </el-button>
              <!--                      -->
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex"
                       :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage"
                       layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
      </div>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
      <delivery-template-import v-if="deliveryTemplateImportVisible" @refreshDataList="getDataList"
                                ref="deliveryTemplateImport"></delivery-template-import>
      <el-dialog width="35%" top="80px" :title="'录入发运信息'" :visible.sync="visiableDialog"
                 style="min-height:100px " @close="closegps" :close-on-click-modal="false">

        <el-form label-width="160px" :inline="true" label-position="left" :rules="dataRule" ref="dataFormAdd"
                 :model="dataFormAdd" size="small" style="margin-bottom:10px">
          <el-form-item label="交货单号" prop="innerCode">
            <el-input size="small" v-model="dataFormAdd.innerCode" placeholder="交货单号" clearable readonly></el-input>
          </el-form-item>
          <el-form-item label="发运日期:" prop="deliveryDate">
            <el-date-picker size="small" v-model="dataFormAdd.deliveryDate" placeholder="发运日期"
                            value-format="yyyy-MM-dd HH:mm:ss" type="dateTime" clearable></el-date-picker>
          </el-form-item>
          <el-form-item label="车牌号:" prop="carNumber">
            <el-input size="small" v-model="dataFormAdd.carNumber" placeholder="车牌号" clearable></el-input>
          </el-form-item>
          <el-form-item label="联系人姓名:" prop="contacts">
            <el-input size="small" v-model="dataFormAdd.contacts" placeholder="联系人姓名" clearable></el-input>

          </el-form-item>
          <el-form-item label="联系人电话:" prop="contactsTel">
            <el-input size="small" v-model="dataFormAdd.contactsTel" placeholder="联系人电话" clearable></el-input>
          </el-form-item>
          <el-form-item label="物流公司名称:" prop="lc">
            <el-input size="small" v-model="dataFormAdd.lc" placeholder="物流公司名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="物流单号:" prop="billCode">
            <el-input size="small" v-model="dataFormAdd.billCode" placeholder="物流单号" clearable></el-input>
          </el-form-item>
        </el-form>
        <div style="margin-bottom: 20px">
          <el-button class="fr" type="primary" size="mini" @click="confirmDelivery()">确认
          </el-button>
        </div>
      </el-dialog>
      <!-- 纸张选择对话框 -->
      <el-dialog
          title="选择打印纸张"
          :visible.sync="paperSelectVisible"
          width="50%"
          :close-on-click-modal="false"
          :show-close="false"
          class="paper-dialog"
      >
        <div class="paper-selection">
          <el-radio-group v-model="selectedPageType" @change="handlePageTypeChange">
            <el-radio :label="3" border class="paper-radio">
              <div class="paper-option">
                <span class="paper-title">A4纸打印（每页4个标签，120*80）</span>
              </div>
            </el-radio>
            <el-radio :label="1" border class="paper-radio">
              <div class="paper-option">
                <span class="paper-title">标签纸打印（每页1个标签，100*80）</span>
              </div>
            </el-radio>
            <el-radio :label="2" border class="paper-radio">
              <div class="paper-option">
                <span class="paper-title">标签纸打印（每页1个标签，120*80）</span>
              </div>
            </el-radio>
          </el-radio-group>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="paperSelectVisible = false">取消</el-button>
          <el-button type="primary" @click="confirmPaperSelection">确定</el-button>
        </div>
      </el-dialog>

    </div>
  </div>
</template>

<script>
import {
  getLabelByValue,
  ASN_STATUS,
  SYNC_STATUS,
  PRODUCTION_ORDER_STATUS,
} from "@/utils/const";
import {
  // getGroupList
  getGroupList4Supplier,
  getSupCompanyList,
} from "@/controller/order"
import {
  fetchDeliveryList4Supplier,
  deleteDelivery,
  exportDelivery,
  editDelivery,
  exportAsnData4Supplier,
  printDelivery,
  printBoxLabel,
  saveLoadBill
  // exportAsnData
} from '@/controller/delivery'
import AddOrUpdate from './delivered-add-or-update'
import DeliveryTemplateImport from './delivery-template-import'
import moment from 'moment'
import {supCompanyList} from "../../../../controller/sys";
// require('@/mock/mockDelivery');
export default {
  data() {
    return {
      visiableDialog: false,
      documentClientHeight: document.documentElement['clientHeight'] - 250,
      dataForm: {
        asncode: '',
        supplierName: '',
        deliveryDateStart: '',
        deliveryDateEnd: '',
        asnStatus: '',
        innerCode: '',
        remark: '',
        rejectReason: '',
        orderCode: '',
        ekgrp: '',
        subcompanyIdList: [],
      },
      dataRule: {
        asncode: [
          {required: true, message: '交货单号不能为空', trigger: 'blur'}
        ],
        deliveryDate: [
          {required: true, message: '发运日期不能为空', trigger: 'blur'}
        ],
      },
      dataFormAdd: {
        asncode: '',
        deliveryDate: '',
        contacts: '',
        contactsTel: '',
        lc: '',
        carNumber: '',
        billCode: '',
        supplierCode: '',
        supplierName: '',
        groupCode: '',
        groupName: '',
        syncStatus: '',
        syncMessage: '',
        werks: '',
        subcompanyId: '',
        innerCode: ''
      },
      supCompanyList: [],
      ASN_STATUS: ASN_STATUS,
      getLabelByValue: getLabelByValue,
      PRODUCTION_ORDER_STATUS: PRODUCTION_ORDER_STATUS,
      dataList: [],
      tenantList: [],
      GOURP_LIST: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      deliveryTemplateImportVisible: false,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
      paperSelectVisible: false,      // 控制纸张选择对话框显示
      selectedPageType: null,            // 默认未选择
      currentPrintRow: null         // 保存当前要打印的行数据
    }
  },
  components: {
    AddOrUpdate,
    DeliveryTemplateImport
  },
  activated() {
    // this.getGroupList();
    this.getGroupList4Supplier();
    this.getDataList();
    this.getSupCompanyList();
  },
  computed: {
    tableHeight: {
      get() {
        return this.$store.state.common.documentClientHeight - 260
      }
    }
  },
  methods: {
    isPrintButtonEnabled(row) {
      console.log('asnStatus:', typeof row.asnStatus, row.asnStatus);
      console.log('syncStatus:', typeof row.syncStatus, row.syncStatus);
      console.log('printFlag:', typeof row.printFlag, row.printFlag);
      // 确保类型转换
      const asnStatus = String(row.asnStatus);
      const syncStatus = String(row.syncStatus);
      const printFlag = Number(row.printFlag);

      const condition1 = ([ '6', '7', '8', '9'].includes(asnStatus) &&
          syncStatus === '2' &&
          printFlag == 1);

      const condition2 = ([ '2','5','7', '8', '9'].includes(asnStatus) &&
          syncStatus === '2' &&
          printFlag == 0);
      console.log('condition1:', condition1)
      console.log('condition2:', condition2)
      return condition1 || condition2;
    },
    //获取子公司列表
    getSupCompanyList() {
      this.supCompanyList = [];
      getSupCompanyList({}).then((data) => {
        if (data.body && data.body.length !== 0) {
          data.body.forEach((info) => {
            const group = {
              key: info.key,
              value: info.value,
              label: info.label
            }
            this.supCompanyList.push(group)
          })
        }
      })
    },
    confirmDelivery() {
      this.$refs['dataFormAdd'].validate((valid) => {
        if (valid) {
          saveLoadBill({...this.dataFormAdd}).then((res) => {
            if (res.code && res.code === '00') {
              this.$message({
                message: '发运信息保存成功',
                type: 'success',
                duration: 1500
              });
              this.visiableDialog = false
              this.getDataList()
            }else if (res.code && res.code === '03') {
              // 处理"数据已存在"的情况
              this.$message({
                message: res.msg || '数据已存在，请检查输入信息',
                type: 'warning',
                duration: 2000
              });
            } else {
              // 处理其他错误情况
              this.$message({
                message: res.msg || '操作失败',
                type: 'error',
                duration: 2000
              });
            }
          })
        } else {
          return false
        }
      })

    },
    openDelivery(row) {
      this.visiableDialog = true
      this.dataFormAdd = Object.assign({}, {...row.loadBill, ...row})
    },
    // 订单状态
    orderStatusFormat: function (value) {
      if (!value) {
        return "";
      }
      return getProductionOrderStatusByValue(PRODUCTION_ORDER_STATUS, value);
    },
    /*// 获取采购组列表
    getGroupList() {
        this.GOURP_LIST = [];
        getGroupList({}).then((data) => {
            if(data.body && data.body.length != 0) {
                data.body.forEach((info) => {
                    const group = {
                        key: info.value,
                        value: info.value,
                        label: info.label
                    }
                    this.GOURP_LIST.push(group)
                })
            }
        })
    },*/
    getGroupList4Supplier() {
      this.GOURP_LIST = [];
      getGroupList4Supplier({}).then((data) => {
        if (data.body && data.body.length !== 0) {
          data.body.forEach((info) => {
            const group = {
              key: info.value,
              value: info.value,
              label: info.label
            }
            this.GOURP_LIST.push(group)
          })
        }
      })
    },
    // 订单关闭按钮
    changeAsnStatus(row) {
      this.$confirm(`确定关闭交货单?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        row.asnStatus = '4',
            editDelivery(row)
                .then((data) => {
                  if (data && data.code === "00") {
                    this.$message({
                      message: '交货单关闭成功',
                      type: 'success',
                      duration: 1500,
                      onClose: () => {
                        this.getDataList()
                      }
                    })
                  } else {
                    this.$message.error(data.msg);
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
      })
    },
    dateFormat: function (row, column) {
      var date = row[column.property]
      if (!date) {
        return ''
      }
      return moment(date).format("YYYY-MM-DD")
    },
    asnStatusFormat: function (value) {
      if (!value) {
        return "";
      }
      return getLabelByValue(ASN_STATUS, value);
    },
    syncStatusFormat: function (value) {
      if (!value) {
        return "";
      }
      return getLabelByValue(SYNC_STATUS, value);
    },
    // 查询按钮
    queryHandle() {
      this.pageIndex = 1;
      this.getDataList();
    },
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true
      fetchDeliveryList4Supplier({
        pageNo: this.pageIndex,
        pageSize: this.pageSize,
        asncode: this.dataForm.asncode,
        supplierCode: this.dataForm.supplierCode,
        'supplierName': this.dataForm.supplierName,
        deliveryDateStart: this.dataForm.deliveryDateStart,
        deliveryDateEnd: this.dataForm.deliveryDateEnd,
        'partCode': this.dataForm.partCode,
        asnStatus: this.dataForm.asnStatus,
        innerCode: this.dataForm.innerCode,
        remark: this.dataForm.remark,
        rejectReason: this.dataForm.rejectReason,
        orderCode: this.dataForm.orderCode,
        groupCode: this.dataForm.ekgrp,
        subcompanyIdList: this.dataForm.subcompanyIdList
      }).then(data => {
        if (data && data.code === '00') {
          console.log('获取到的数据:', data.body.records);
          this.$set(this, 'dataList', data.body.records);
          this.totalPage = data.body.total;
          // 强制更新组件
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        } else {
          this.dataList = []
          this.totalPage = 0
        }
      }).catch((e) => {
        console.log(e)
      }).finally(() => {
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val
    },
    // 新增 / 修改
    addOrUpdateHandle(row) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(row, row ? row.id : null, 'edit')
      })
    },
    viewHandle(row) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(row, row ? row.id : null, 'view')
      })
    },
    // 删除
    deleteHandle(id) {
      this.$confirm(`确定进行删除操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteDelivery({}, id).then(data => {
          if (data && data.code === '00') {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },

    exportData(rec) {
      printDelivery(rec).then(data => {
        if (data && data.code === '00') {
          this.readAsBinaryString1(data.body)
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 1500,
            onClose: () => {
               this.getDataList()
            }
          })
        } else {
          this.$message.error(data.msg)
        }
      })
    },

    // exportBoxLabelData(rec) {
    //   printBoxLabel(rec).then(data => {
    //     if (data && data.code === '00') {
    //       this.readAsBinaryString1(data.body)
    //       this.$message({
    //         message: '操作成功',
    //         type: 'success',
    //         duration: 1500,
    //         onClose: () => {
    //           // this.getDataList()
    //         }
    //       })
    //     } else {
    //       this.$message.error(data.msg)
    //     }
    //   })
    // },
    // 打开导入窗口
    importTemplate() {
      this.deliveryTemplateImportVisible = true
      this.$nextTick(() => {
        this.$refs.deliveryTemplateImport.init()
      })
    },
    // 批量导出交货单信息
    exportASNData() {
      // 校验：ASN编码、内向交货单号、订单号都为空时，供货日期必须填写且区间不超过12个月
      const hasSpecificCondition = this.dataForm.asncode || this.dataForm.innerCode || this.dataForm.orderCode
      if (!hasSpecificCondition) {
        if (!this.dataForm.deliveryDateStart || !this.dataForm.deliveryDateEnd) {
          this.$message.warning('请输入起始供货日期和截止供货日期')
          return
        }
        const start = new Date(this.dataForm.deliveryDateStart)
        const end = new Date(this.dataForm.deliveryDateEnd)
        const diffDays = Math.ceil((end - start) / (1000 * 60 * 60 * 24))
        if (diffDays < 0) {
          this.$message.warning('截止供货日期不能小于起始供货日期')
          return
        }
        if (diffDays > 365) {
          this.$message.warning('供货日期区间不能超过12个月')
          return
        }
      }
      const params = {
        ids: [],
        asnCode: this.dataForm.asncode,
        supplierCode: this.dataForm.supplierCode,
        partCode: this.dataForm.partCode,
        'supplierName': this.dataForm.supplierName,
        deliveryDateStart: this.dataForm.deliveryDateStart,
        deliveryDateEnd: this.dataForm.deliveryDateEnd,
        asnStatus: this.dataForm.asnStatus,
        innerCode: this.dataForm.innerCode,
        orderCode: this.dataForm.orderCode,
        ekgrp: this.dataForm.ekgrp
      }
      exportAsnData4Supplier(params).then((data) => {
        if (data && data.code == '00') {
          this.readAsBinaryString(data.body)
        } else {
          this.$message.error(data.msg)
        }
      }).catch((e) => {
        console.log(e)
      })
    },
    readAsBinaryString(data) {
      // const name = decodeURI(res.headers['content-disposition'].split('filename=')[1]);
      // const blob = new Blob(content, {type: 'application/vnd.ms-excel;charset=utf-8'}); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
      const blob = this.str2Blob(data.content, 'application/vnd.ms-excel;charset=utf-8'); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
      const url = window.URL.createObjectURL(blob); // URL.createObjectURL(object)表示生成一个File对象或Blob对象
      let dom = document.createElement('a'); // 设置一个隐藏的a标签，href为输出流，设置download
      dom.style.display = 'none';
      dom.href = url;
      dom.setAttribute('download', decodeURI(data.fileName)); // 指示浏览器下载url,而不是导航到它；因此将提示用户将其保存为本地文件
      document.body.appendChild(dom);
      dom.click();
    },
    readAsBinaryString1(data) {
      // 将二进制字符串转换为ArrayBuffer
      const byteCharacters = atob(data.content);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], {type: 'application/pdf'});

      // 创建隐藏的iframe用于打印
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = URL.createObjectURL(blob);

      // 监听iframe加载完成事件
      iframe.onload = function () {
        try {
          // 等待一小段时间确保PDF完全加载
          setTimeout(() => {
            // 调用iframe内部的打印功能
            if (iframe.contentWindow) {
              iframe.contentWindow.focus();
              iframe.contentWindow.print();
            }
            // 打印完成后可以选择移除iframe
            // setTimeout(() => document.body.removeChild(iframe), 1000);
          }, 1000);
        } catch (error) {
          console.error('打印失败:', error);
          alert('打印失败，请尝试下载后打印。');
          // 提供下载备选方案
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = decodeURI(data.fileName);
          a.click();
        }
      };

      // 添加iframe到文档
      document.body.appendChild(iframe);
    },
    str2Blob(str, mime) {
      var arr = str.split(',')
      var bstr = atob(arr[0]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {
        type: mime
      });
    },
    getStatusClass(status) {
      let className = ''
      switch (status) {
        case '0':
        case '1':
          className = "text-primary"
          break;
        case '3':
          className = "text-danger"
          break;
        default:
          className = 'text-success'
          break;
      }
      return className
    },
    // 新增方法：确认纸张选择并执行打印
    confirmPaperSelection() {
      if (this.currentPrintRow) {
        // 调用打印接口，并传递pageType参数
        printBoxLabel({
          ...this.currentPrintRow,
          pageType: this.selectedPageType  // 添加pageType参数
        }).then(data => {
          if (data && data.code === '00') {
            this.readAsBinaryString1(data.body);
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500
            });
          } else {
            this.$message.error(data.msg);
          }
        });
      }
      this.paperSelectVisible = false;
      this.currentPrintRow = null;
      this.getDataList();
    },

    // 修改原有的箱标签打印方法
    exportBoxLabelData(rec) {
      // 不直接打印，而是先保存当前行数据并显示纸张选择对话框
      this.currentPrintRow = rec;
      this.paperSelectVisible = true;
      // 默认选中A4纸打印
      this.selectedPageType = rec.pageType;
    },
  }
}
</script>

<style lang="scss" scoped>
:deep(.fixed-dropdown) {
  position: fixed !important;
  z-index: 9999 !important;

  /* 修复多选标签高度问题 */
  .el-select-dropdown__list {
    max-height: 300px;
    overflow-y: auto;
  }
}

/* 子公司选择框样式 */
.input-width {
  width: 300px;

  /* 限制多选标签高度 */
  :deep(.el-select__tags) {
    max-height: 80px;
    overflow-y: auto;
    flex-wrap: wrap;
    align-items: flex-start;
    padding: 2px 0;

    .el-tag {
      margin: 2px 4px 2px 0;
      max-width: 100px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.fixed-dropdown {
  position: fixed !important;
  z-index: 9999 !important;
}

/* 限制多选标签高度 */
.input-width {
  ::v-deep .el-select__tags {
    max-height: 80px;
    overflow-y: auto;
    flex-wrap: wrap; /* 关键：允许标签换行 */
    align-items: flex-start; /* 顶部对齐 */
    padding: 2px 0; /* 减少内边距 */

    .el-tag {
      margin: 2px 4px 2px 0;
      max-width: 100px; /* 限制标签宽度 */
      overflow: hidden;
      text-overflow: ellipsis; /* 长文本显示省略号 */
    }
  }

  /* 固定输入框高度 */
  ::v-deep .el-select__input {
    height: 32px; /* 保持与标准输入框相同高度 */
  }
}

.button-danger {
  color: #F56C6C
}

.text-danger {
  color: #F56C6C
}

.text-success {
  color: #67C23A
}

.text-waming {
  color: #E6A23C;
}

.text-info {
  color: #909399;
}

.fr {
  float: right;
}

// 纸张选择区域样式
.paper-selection {
  display: flex;
  gap: 20px;
  justify-content: center; // 让选项居中排列更美观
  padding: 10px 0;

  .paper-radio {
    // 调整外框大小（宽度和高度）
    width: 280px; // 固定宽度，根据需要调整
    height: 100px; // 增加高度，让外框更大
    // 增大下边距
    margin-bottom: 20px; // 调整此值控制下边距大小
    // 其他样式保持不变
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center; // 文字垂直居中
    border: 1px solid #dcdcdc;
    border-radius: 6px; // 稍微增大圆角更美观
    padding: 15px;
    box-sizing: border-box;
    cursor: pointer;
    transition: all 0.2s; // 增加过渡效果

    // 选中状态样式强化
    &:checked {
      border-color: #409eff; // 选中时边框变色
      background-color: #f0f7ff; // 轻微背景色变化
    }

    // 悬停效果
    &:hover {
      border-color: #409eff;
    }
  }

  .paper-radio:nth-child(1) {
    margin-left: 10px; /* 根据实际偏差调整数值，比如 -10px 等 */
  }

  .paper-option {
    text-align: center;
  }

  .paper-title {
    font-size: 15px; // 稍微增大字体
    font-weight: 500;
  }
}
</style>
